import React from "react";
import styles from "./Footer.module.css";

function Footer() {
    return (
        <>
            <div className={styles.footer}>
                <div className={styles.footerContainer}>

                    <div className={styles.logoSection}>
                        <img src="/images/oya-coincierge.svg" alt="logo" width={100} className={styles.logoIcon} />
                        <p>Your trusted digital concierge platform for lifestyle and business services.</p>
                    </div>


                    <div className={styles.aboutContainer}>

                        <div className={`${styles.aboutInfo}`}>
                            <strong>Services</strong>
                            <p>Browse Services</p>
                            <p>Errand Running</p>
                            <p>Travel Assistance</p>
                            <p>Event Planning</p>
                        </div>

                        <div className={`${styles.aboutInfo}`}>
                            <strong>Company</strong>
                            <p>About Us</p>
                            <p>Blog</p>
                            <p>Careers</p>
                            <p>Contact Us</p>
                        </div>

                        <div className={`${styles.aboutInfo}`}>
                            <strong>Support</strong>
                            <p>Help Center</p>
                            <p>Privacy Policy</p>
                            <p>Terms of Service</p>
                            <p></p>
                        </div>
                    </div>
                </div>

                <div className={styles.socials}>
                    <p className={styles.socialText}>© 2026 Oya Concierge. All rights reserved.</p>

                    <div className={styles.socialImg}>
                        <a href="#!"><img src="./images/twitter-x.svg" alt="X/Twitter logo" /></a>
                        <a href="#!"><img src="./images/insta.svg" alt="Instagram logo" /></a>
                        <a href="#!"><img src="./images/linkedin.svg" alt="LinkedIn logo" /></a>
                    </div>

                </div>
            </div>
        </>
    );
}

export default Footer